import { openProfilePictureUploadModal, openSamplesRequestModal, openTeamMembersModal } from "@faire/retailer-visitor-shared/components/App/AppModals/utils";
import { getSamplesRequestModalSourceFromDisplayPageType } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/__internal__/getSamplesRequestModalSourceFromDisplayPageType";
import { safeScrollTo } from "@faire/retailer-visitor-shared/lib/safeScrollTo";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { trackClientEvent } from "@faire/web-api--source/trackClientEvent";
var noOpSDUIActionHandler = function() {};
export function SDUIOnViewActionsHandler(actions, loggingData, history, recordMilestoneOnceByDay, clearAllFilters, maybeAssignCategoryTreeExperiment, dismissConductorComponentHandler) {
    var actionHandlers = actions.map(function(action) {
        if (action.navigate) {
            return getSDUINavigateActionHandler(history, action.navigate.link);
        } else if (action.record_milestone) {
            return getSDUIRecordMilestoneHandler(recordMilestoneOnceByDay, action.record_milestone.milestone);
        } else if (action.open_modal) {
            return getSDUIOpenModalActionHandler(history, action.open_modal, loggingData);
        } else if (action.clear_filter) {
            return clearAllFilters;
        } else if (action.assign_setting) {
            return getSDUIAssignSettingActionHandler(action.assign_setting);
        } else if (action.log_event) {
            return getSDUILogEventActionHandler(action.log_event);
        } else if (action.record_category_nodes_visibility) {
            return getSDUIRecordCategoryNodesVisibilityActionHandler(action.record_category_nodes_visibility, maybeAssignCategoryTreeExperiment);
        } else if (action.scroll_action) {
            return getSDUIScrollActionHandler(action.scroll_action);
        } else if (action.dismiss) {
            var _actions_find_dismiss, _actions_find;
            var conductorComponentToken = (_actions_find = actions.find(function(action) {
                var _action_dismiss;
                return (_action_dismiss = action.dismiss) === null || _action_dismiss === void 0 ? void 0 : _action_dismiss.conductor_component_token;
            })) === null || _actions_find === void 0 ? void 0 : (_actions_find_dismiss = _actions_find.dismiss) === null || _actions_find_dismiss === void 0 ? void 0 : _actions_find_dismiss.conductor_component_token;
            if (conductorComponentToken) {
                return dismissConductorComponentHandler(conductorComponentToken);
            }
            return noOpSDUIActionHandler;
        }
        return noOpSDUIActionHandler;
    });
    actionHandlers.forEach(function(actionHandler) {
        actionHandler();
    });
}
function getSDUINavigateActionHandler(history, link) {
    return function() {
        if (link) {
            history.push(link);
        }
    };
}
function getSDUIRecordMilestoneHandler(milestoneRecorder, milestone) {
    return function() {
        milestoneRecorder(milestone);
    };
}
function getSDUIAssignSettingActionHandler(assignSettingAction) {
    return function() {
        return assignSettingOnEvent(assignSettingAction.setting_name);
    };
}
function getSDUILogEventActionHandler(logEventAction) {
    return function() {
        if (!logEventAction.event_name) {
            return;
        }
        trackClientEvent({
            eventKey: logEventAction.event_name,
            parameters: logEventAction.parameters
        });
    };
}
function getSDUIOpenModalActionHandler(history, openModalAction, loggingData) {
    if (openModalAction.open_brand_sample_modal) {
        return function() {
            var _openModalAction_open_brand_sample_modal;
            var _openModalAction_open_brand_sample_modal_brand_token;
            return openSamplesRequestModal(history, (_openModalAction_open_brand_sample_modal_brand_token = (_openModalAction_open_brand_sample_modal = openModalAction.open_brand_sample_modal) === null || _openModalAction_open_brand_sample_modal === void 0 ? void 0 : _openModalAction_open_brand_sample_modal.brand_token) !== null && _openModalAction_open_brand_sample_modal_brand_token !== void 0 ? _openModalAction_open_brand_sample_modal_brand_token : "", getSamplesRequestModalSourceFromDisplayPageType(loggingData.view_display_page));
        };
    }
    if (openModalAction.open_team_member_modal) {
        return function() {
            return openTeamMembersModal(history);
        };
    }
    if (openModalAction.open_profile_pic_upload_modal) {
        return function() {
            return openProfilePictureUploadModal(history);
        };
    }
    return noOpSDUIActionHandler;
}
function getSDUIRecordCategoryNodesVisibilityActionHandler(recordCategoryNodesVisibilityAction, maybeAssignCategoryTreeExperiment) {
    return function() {
        return maybeAssignCategoryTreeExperiment(function() {
            return recordCategoryNodesVisibilityAction.category_path_identifiers;
        }, recordCategoryNodesVisibilityAction.source);
    };
}
function getSDUIScrollActionHandler(scrollAction) {
    return function() {
        if (scrollAction.page_top) {
            safeScrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };
}
